import script from "./Paging.vue?vue&type=script&setup=true&lang=js"
export * from "./Paging.vue?vue&type=script&setup=true&lang=js"

import "./Paging.vue?vue&type=style&index=0&id=237ad2a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-237ad2a9"]])

export default __exports__